<template>
  <div>
    <transition name="message-fade">
      <div v-if="visible" class="el-message-box__wrapper" @click="cancale">
        <div class="el-message-box" @click.stop="stopfn">
          <div class="el-message-box__header">
            <div class="el-message-box__title"></div>
            <button
              type="button"
              aria-label="Close"
              class="el-message-box__headerbtn"
              @click="cancale"
            >
              <i class="el-message-box__close jl-icon-close"></i>
            </button>
          </div>
          <div class="el-message-box__content">
            <div class="jl-modal-box">
              <div class="main-info-form">
                <h2 class="main-title">用户登录</h2>
                <div class="form-ground">
                  <label class="form-label">用户账号:</label>
                  <div class="form-el-wrap">
                    <input
                      type="text"
                      v-model.trim="phone"
                      :class="[isPhoneError?'form-input error':'form-input']"
                      placeholder="请输入账号"
                      @blur="checkPhone"
                    >
                    <div v-if="isPhoneError" class="error-text">请输入账号</div>
                  </div>
                </div>
                <div class="form-ground">
                  <label class="form-label">账号密码:</label>
                  <div class="form-el-wrap">
                    <input
                      type="password"
                      v-model.trim="password"
                      :class="[isPasswordError?'form-input error':'form-input']"
                      placeholder="请输入密码"
                      @blur="checkPassword"
                    >
                    <div v-if="isPasswordError" class="error-text">请输入密码</div>
                  </div>
                </div>
                <div class="form-ground">
                  <button
                    type="button"
                    class="el-button el-button--default el-button--small el-button--primary"
                    @click="confirm"
                  >
                    <span>登录</span>
                  </button>
                  <button
                    type="button"
                    class="el-button el-button--default el-button--small"
                    @click="goRegister"
                  >
                    <span>注册</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="visible" class="v-shaow-modal"></div>
  </div>
</template>

<script>
import { storeInfoCrypt } from "@/utils/storeInfoCrypt";
import { login } from "@/api/user";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  name: "login-box",
  data() {
    return {
      phone: "",
      password: "",
      isPhoneError: false,
      isPasswordError: false
    };
  },
  methods: {
    stopfn() {},
    checkPhone() {
      this.isPhoneError = !this.phone ? true : false;
    },
    checkPassword() {
      this.isPasswordError = !this.password ? true : false;
    },
    close() {
      this.$store.dispatch("setShowLoginModel", false);
      Object.assign(this.$data, this.$options.data());
    },
    confirm() {
      this.checkPhone();
      this.checkPassword();
      if (this.isPhoneError || this.isPasswordError) return;
      login(this, res => {
        if (res.data && res.data.frontUser) {
          let obj = res.data.frontUser;
          obj.userId = obj.id;
          this.$store.dispatch("setUserInfo", obj);
          localStorage.setItem("token", obj.token);
          storeInfoCrypt(this.$store.state);
          if (this.$route.name === "auctionDetailIndex") {
            this.$bus.$emit("checkDepositType", true);
          }
        }
        this.close();
      });
    },
    cancale() {
      this.close();
    },
    goRegister() {
      this.$router.push({
        name: "register"
      });
    },
    //提示
    tips(text) {
      this.$message({
        type: "warning",
        message: text
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-el-wrap {
  position: relative;
  padding-bottom: 20px;
  .error-text {
    position: absolute;
    left: 3px;
    bottom: 0;
    font-size: 12px;
    color: #e81727;
    line-height: 20px;
  }
}
.main-info-form {
  .main-title {
    text-align: center;
    margin-bottom: 20px;
  }
  .form-ground {
    position: relative;
    padding-left: 69px;
    &:last-child {
      margin-bottom: 0;
    }
    .form-label {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      color: #333;
      line-height: 42px;
    }
    .form-input {
      display: block;
      width: 100%;
      height: 42px;
      background: transparent;
      border: 1px solid #ccc;
      padding: 0 13px;
      border-radius: 3px;
      &.error {
        border-color: #e81727;
      }
    }
    .btn {
      width: 100px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      color: #e81727;
      border: 1px solid #e81727;
      background: transparent;
      cursor: pointer;
      outline: none;
      margin-right: 15px;
      &.active {
        color: #fff;
        background: #e81727;
        border-color: #e81727;
      }
    }
  }
}
</style>


<style scoped>
.message-fade-enter-active,
.message-fade-leave-active {
  transition: all 0.3s ease;
}
.message-fade-enter, .message-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}
.el-message-box__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1000;
}
.el-message-box__wrapper:after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}
.el-message-box {
  display: inline-block;
  width: 420px;
  height: 300px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  backface-visibility: hidden;
  background-image: url("../assets/img/zkj-m-login-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: -30px;
}
.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
}
.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: #303133;
}
.el-message-box__content {
  position: relative;
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
}
.el-message-box__status + .el-message-box__message {
  padding-left: 36px;
  padding-right: 12px;
}
.el-message-box__status {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px !important;
}

.el-message-box__headerbtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
}
.el-message-box__headerbtn .el-message-box__close {
  color: #909399;
}
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
}
.el-message-box__btns {
  padding: 5px 20px 0;
  text-align: right;
}

.el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.el-button--small {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
}
.el-message-box__btns button:nth-child(2) {
  margin-left: 10px;
}
.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.el-message-box__status.jl-icon-warning {
  color: #e6a23c;
}
.v-shaow-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 999;
}
</style>
